var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxErrorYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16685 8.33398H10.8335V12.5007H9.16685V8.33398ZM9.16602 13.334H10.8327V15.0007H9.16602V13.334Z",
    fill: "#FBBF24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4741 3.50023C11.1841 2.9544 10.6191 2.61523 10.0008 2.61523C9.38244 2.61523 8.81744 2.9544 8.52744 3.50107L2.41244 15.0536C2.27674 15.3073 2.20953 15.5919 2.21742 15.8795C2.22531 16.1671 2.30804 16.4477 2.45744 16.6936C2.60469 16.9406 2.8138 17.1449 3.06415 17.2863C3.31449 17.4278 3.59739 17.5015 3.88494 17.5002H16.1166C16.7066 17.5002 17.2408 17.1986 17.5449 16.6936C17.6941 16.4476 17.7767 16.1671 17.7846 15.8795C17.7925 15.592 17.7254 15.3073 17.5899 15.0536L11.4741 3.50023ZM3.88494 15.8336L10.0008 4.28107L16.1208 15.8336H3.88494Z",
    fill: "#FBBF24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxErrorYellow);
export default __webpack_public_path__ + "static/media/bx-error-yellow.c55f98308a5b86e1ff5871d6d2f712f7.svg";
export { ForwardRef as ReactComponent };